var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowForward24Px(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow_forward_24px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon/navigation/arrow_forward_24px",
    d: "M10.0003 16.6665L11.1753 15.4915L6.52533 10.8332H16.667V9.1665H6.52533L11.1753 4.50817L10.0003 3.33317L3.33366 9.99984L10.0003 16.6665Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowForward24Px);
export default __webpack_public_path__ + "static/media/arrow_forward_24px.1dafdd20ab738c937ab22e3cebe603db.svg";
export { ForwardRef as ReactComponent };